module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"navTenantMenuList.tenantSettings":"Settings","navTenantMenuList.chooseTenant":"Change Tenant..."}}')
  delete Component.options._Ctor
}
